import { contenuPosePushTutosNoticesMock, titreBudgetMock } from '@mock/schema/components';
import { pageBase } from '@mock/schema/slugs/config';
import { SlugPage } from '@pages/slug-page/models';

const blocks = [titreBudgetMock('pose-perso'), contenuPosePushTutosNoticesMock];

export const laPosePersoMock: SlugPage = {
  ...pageBase({
    title: 'Pose soi-même',
    type: 'la-pose',
    language: 'fr-FR',
    headerId: 'header-fr',
    footerId: 'footer-fr',
    isBreadcrumbOverlay: false,
  }),
  blocks,
};
